import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigurationService } from '../core/configuration.service';
import { ContextService } from '../core/context.service';

@Injectable()
export class PasswordPolicyService {
  private baseApiUrl: string;

  constructor(private configurationService: ConfigurationService,
    private contextService: ContextService, private httpClient: HttpClient) {
    this.baseApiUrl = this.configurationService.BaseApiUrl;
  }

  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'passwordpolicy').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, isMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `passwordpolicy/${id}?isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(passwordPolicyDetails: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'passwordpolicy', passwordPolicyDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(editedPasswordPolicyDetails: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'passwordpolicy', editedPasswordPolicyDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
  return this.httpClient.post(this.baseApiUrl + 'passwordpolicy/authorise', id).pipe(
    map((res: Response) => res),
    catchError((err: any) => {
      // Backend returns { Code: "Error", Message: "Creator and Authoriser can not be same" }
      // ASP.NET serializes as camelCase by default: { code, message }
      const backendMessage =
        (err && err.error && (err.error.message || err.error.Message)) ||
        (err && err.message) ||
        'Server error';
      return observableThrowError(backendMessage);
    }));
}

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `passwordpolicy/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean): Observable<any> {
    // Backend only has GET all - filter client-side or call getAll
    return this.getAll();
  }
}